<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import AppLoader from '@/components/AppLoader.vue';
import App from '@/App.vue';
import { configureAxiosInterceptor } from './api';

const route = useRoute();
onMounted(() => {
  configureAxiosInterceptor(route);
});
</script>

<template>
  <Suspense>
    <template #fallback>
      <AppLoader full />
    </template>

    <template #default>
      <App />
    </template>
  </Suspense>
</template>
